
import { FormInputWrapper } from '@myxplor/forms'
import { CalendarIcon } from '@myxplor/icons'
import moment from 'moment'
import React, { Component } from 'react'
import DayPickerInput from 'react-day-picker/DayPickerInput'
import 'react-day-picker/lib/style.css'
import { formatDate, parseDate } from 'react-day-picker/moment'

const DATE_FORMAT_EXTERNAL = 'YYYY-MM-DD'

export default class AnyDayPicker extends Component {

  constructor(props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(day) {
    if (day) {
      this.props.onChange(this.props.name, moment(day).format(DATE_FORMAT_EXTERNAL))
    }
  }

  render() {
    const {
      name,
      required,
      label,
      errors,
      loading,
      value
    } = this.props

    return (
      <FormInputWrapper
        name={name}
        label={label}
        required={required}
        errors={errors}
        loading={loading}
      >
        <DayPickerInput
          formatDate={formatDate}
          parseDate={parseDate}
          onDayChange={this.handleChange}
          selectedDays={value}
          value={value ? moment(value, DATE_FORMAT_EXTERNAL).format(DATE_FORMAT_EXTERNAL) : ''}
          placeholder={DATE_FORMAT_EXTERNAL}
          format={DATE_FORMAT_EXTERNAL}
        />
        <CalendarIcon className="formDatePicker--icon" />
      </FormInputWrapper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccs-gov-enrolments/actions/create-enrolment/any-day-picker.jsx